import cookieCommons from 'common/cookieCommons';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { postUserAvatar } from '../../../../apis/profile.api';
import { USER_INFO } from '../../../../constant/QueryKeyName';
import { DEFAULT_AVT_IMG } from '../../../../constant/imgImport';
import Avatar from '../../../image/Avatar';
import AvatarCropper from '../../../image/AvatarCropper';

const BusinessInfoAvatar = ({
  canEdit,
  avatarUrl,
}: {
  canEdit: boolean;
  avatarUrl: string | null;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();

  return (
    <>
      <Avatar
        canEdit={canEdit}
        positionClass="left-1 md:left-10 -bottom-20"
        handleClickEdit={() => setOpenModal(true)}
        imgProps={{
          src: avatarUrl || DEFAULT_AVT_IMG,
          className:
            'rounded-full overflow-hidden drop-shadow-[0px_10px_40px_rgba(0,0,0,0.25)] lg:w-[164px] lg:h-[164px] w-[128px] h-[128px]',
        }}
      />
      <AvatarCropper
        open={openModal}
        toggle={() => setOpenModal(false)}
        onSuccess={() => {
          const userId = cookieCommons.getQbankUserId();
          if (userId) {
            queryClient.refetchQueries([USER_INFO, userId], { active: true });
          }
        }}
        asyncFunc={(avatar: File) => postUserAvatar({ avatar })}
      />
    </>
  );
};

export default BusinessInfoAvatar;
